import { CALL_API, Schemas } from '../../common/middleware/api';

export const ROLES_REQUEST = 'ROLES_REQUEST';
export const ROLES_SUCCESS = 'ROLES_SUCCESS';
export const ROLES_FAILURE = 'ROLES_FAILURE';

export const ROLES_UNPAGED_REQUEST = 'ROLES_UNPAGED_REQUEST';
export const ROLES_UNPAGED_SUCCESS = 'ROLES_UNPAGED_SUCCESS';
export const ROLES_UNPAGED_FAILURE = 'ROLES_UNPAGED_FAILURE';

export const ROLE_FETCH_REQUEST = 'ROLE_GET_REQUEST';
export const ROLE_FETCH_SUCCESS = 'ROLE_GET_SUCCESS';
export const ROLE_FETCH_FAILURE = 'ROLE_GET_FAILURE';

export const ROLE_CREATE_REQUEST = 'ROLE_CREATE_REQUEST';
export const ROLE_CREATE_SUCCESS = 'ROLE_CREATE_SUCCESS';
export const ROLE_CREATE_FAILURE = 'ROLE_CREATE_FAILURE';

export const ROLE_UPDATE_REQUEST = 'ROLE_UPDATE_REQUEST';
export const ROLE_UPDATE_SUCCESS = 'ROLE_UPDATE_SUCCESS';
export const ROLE_UPDATE_FAILURE = 'ROLE_UPDATE_FAILURE';

export const loadRoles = (options) => ({
	[CALL_API]: {
		types: [ROLES_REQUEST, ROLES_SUCCESS, ROLES_FAILURE],
		endpoint: 'api/roles',
		request: options,
		schema: Schemas.ROLE_ARRAY
	}
});

export const loadUnpagedRoles = (options) => ({
	[CALL_API]: {
		types: [ROLES_UNPAGED_REQUEST, ROLES_UNPAGED_SUCCESS, ROLES_UNPAGED_FAILURE],
		endpoint: 'api/roles/unpaged',
		request: options,
		schema: Schemas.ROLE_ARRAY
	}
});

export const fetchRole = (id) => ({
	[CALL_API]: {
		types: [ROLE_FETCH_REQUEST, ROLE_FETCH_SUCCESS, ROLE_FETCH_FAILURE],
		endpoint: `api/roles/${id}`,
		schema: Schemas.ROLE
	}
});

export const createRole = (role, history) => ({
	[CALL_API]: {
		types: [ROLE_CREATE_REQUEST, ROLE_CREATE_SUCCESS, ROLE_CREATE_FAILURE],
		endpoint: 'api/roles',
		method: 'POST',
		request: role,
		schema: Schemas.ROLE,
		form: 'role',
		transition: {
			history,
			successPath: (response) => {
				return '/roles';
			}
		}
	}
});

export const updateRole = (id, role) => ({
	[CALL_API]: {
		types: [ROLE_UPDATE_REQUEST, ROLE_UPDATE_SUCCESS, ROLE_UPDATE_FAILURE],
		endpoint: `api/roles/${id}`,
		method: 'PUT',
		request: role,
		schema: Schemas.ROLE,
		form: 'role'
	}
});